var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39098 3.28169C7.71827 3.28169 7.17293 3.87759 7.17293 4.61268V20.3873C7.17293 21.1224 7.71827 21.7183 8.39098 21.7183H15.609C16.2817 21.7183 16.8271 21.1224 16.8271 20.3873V4.61268C16.8271 3.87759 16.2817 3.28169 15.609 3.28169H8.39098ZM6 4.61268C6 3.16974 7.07048 2 8.39098 2H15.609C16.9295 2 18 3.16974 18 4.61268V20.3873C18 21.8303 16.9295 23 15.609 23H8.39098C7.07048 23 6 21.8303 6 20.3873V4.61268Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 20C10.5 19.7239 10.7646 19.5 11.0909 19.5H12.9091C13.2354 19.5 13.5 19.7239 13.5 20C13.5 20.2761 13.2354 20.5 12.9091 20.5H11.0909C10.7646 20.5 10.5 20.2761 10.5 20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.5C10.5 3.22386 10.7646 3 11.0909 3H12.9091C13.2354 3 13.5 3.22386 13.5 3.5C13.5 3.77614 13.2354 4 12.9091 4H11.0909C10.7646 4 10.5 3.77614 10.5 3.5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.8912f605.svg";
export { ForwardRef as ReactComponent };